const Vue = require("vue").default

function rubleFunc(value) {
    if (!value) return ''
    return value.toString() + '\u0020'+'\u20bd';
}
  
Vue.filter('r', rubleFunc)
Vue.filter('rub', rubleFunc)